export default {
  inscricao: { id: 0 },
  login: {},
  dadosTitular: {},
  nisECpf: false,
  dadosConjuge: {},
  profissoes: [],
  cidades: [],
  dependentes: [],
  informacoesDaFamilia: {},
  programasSociais: {},
  menu: { pendenciasDaInscricao: [], possuiInformacoesMinimasPreenchidas: false },
  moradia: {},
  endereco: {},
  imoveis: [],
  distritos: [],
  empreendimentos: [],
  requisicoesAjax: 0,
  Nis:{},
  ehNovaInscricao: false,
  informacoesDeLocalDeAtendimento: { localDeAtendimento: {}, podeAlterarLocalDeAtendimento: false },
  usuario: {},
  ehAcessoAdministrativo: false,
  grauDeInstrucoes: [],
  regimesDeCasamento: [],
  etnias: [],
  questoesDoFormulario: [],
  ehFormularioSomenteLeitura: false,
  deveCarregarInscricaoNaMemoria: false,
  demandasEspecificas:[],
  cidadesDoBrasil: [],
  tiposDeDeficiencia: []
};